var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-client-form"},[_c('v-row',[_c('v-col',[_c('h3',[_vm._v(" Contact via phone")]),_c('h5',{staticClass:"text-gray"},[_vm._v("Speak to your care concierge "),_c('a',{staticClass:"pointer light-blue-text text-underline",attrs:{"href":"tel:+813-555-1212"}},[_vm._v("813-555-1212")])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }